import moment from "moment";

const fromDate = (weeks_ago = 2) => moment()
    .subtract(weeks_ago, "weeks")
    .format("YYYY.MM.DD");

export default fromDate;